export const my_membership_detail_path = 'my_memberships/detail';
export const my_memberships_path = 'my_memberships';
export const my_membership_support_path = 'my_memberships/support_detail';
export const my_membership_commission_path = 'my_memberships/commission_detail';
